export class NztcsTaxonSearchCriteria {
  name: string;
  rank: string;
  speciesType: string;
  pageNumber = 1;
  pageSize = 25;

  constructor() {}
}
